module.exports = __webpack_public_path__ + "img/grid-active.8c7dbd0c.svg";